import React, {useEffect, useState} from "react";
import Box from "../../lib/appfuse-react/component/Box";
import Paper from "../../lib/appfuse-react/component/Paper";
import trafficInfoService from "../../service/trafficInfo/trafficInfoService";
import CircularProgress from "../../lib/appfuse-react/component/CircularProgress";
import {Grid, Typography} from "@material-ui/core";
import {makeStyles, useTheme} from "@material-ui/core/styles";
import {useSelector} from "../../store";
import {isAuthenticated} from "../../reducer/iam/authReducer";
import {withDesktop} from "../../layout/Desktop";
import {withExplorer} from "../../layout/Explorer";
import ajax from "../../lib/appfuse-react/core/ajax";
import useResponsive from "../../lib/appfuse-react/hook/useResponsive";

function TrafficInfoContent() {
    const [ready, setReady] = useState(false);
    const [value, setValue] = useState([]);
    const responsive = useResponsive();
    const isMobile = !responsive.isLargeScreen();

    useEffect(() => {
        (async () => {
            const data = await trafficInfoService.find();
            setValue(data);
            setReady(true);
        })();
    }, []);

    const padding = isMobile ? 0 : 4;

    return (
        <Box fullHeight fullWidth>
            <Paper fullHeight fullWidth square variant='outlined'>
                <CircularProgress value={ready}>
                    <Box fullHeight fullWidth padding={padding} overflow='auto'>
                        {value.map((info, index) => <InfoTypography key={index} value={info}/>)}
                    </Box>
                </CircularProgress>
            </Paper>
        </Box>
    );
}

const useStyles = makeStyles((theme) => ({
    pre: {
        whiteSpace: 'pre-wrap'
    }
}));

function InfoTypography(props) {
    const classes = useStyles();
    const {value} = props;
    const responsive = useResponsive();
    const isMobile = !responsive.isLargeScreen();

    const padding = isMobile ? 2 : 4;

    const data = [
        {text: '地點', value: value.location},
        {text: '地址', value: value.address},
        {text: '交通方式', value: value.transportation, nextLine: true, photo: value.googleMap, googleMapLink: value.googleMapLink},
    ];

    const getInfo = (data, index) => {
        const {text, value, nextLine=false, photo, googleMapLink = ''} = data;
        const {word, href} = value;

        const valueText = href? <a href={href}>{href}</a>: word? word:value;
        const imageUrl = photo && ajax.resolve(photo);

        const width = isMobile? '100%': '45%';

        const handleClicked = () => {
            window.open(googleMapLink);
        }

        return (
            <Grid item xs={12} key={index}>
                <Box display='flex' flexDirection='column' fullWidth>
                    <Typography component='p' variant='subtitle1'><b>{text}</b>：{!nextLine? valueText:''}</Typography>
                    {nextLine && (<Typography component='pre' className={classes.pre}>{valueText}</Typography>)}
                    {
                        imageUrl && (
                            <img src={imageUrl} alt={text} style={{width: width, height: 'auto', marginTop: 20}} onClick={handleClicked}/>
                        )}
                </Box>
            </Grid>
        );
    };


    return (
        <Box fullWidth padding={padding}>
            <Box paddingY={2}>
                <Typography variant='h6'>{value.class}</Typography>
            </Box>
            <Grid container spacing={2}>
                {data.map((info, index) => getInfo(info, index))}
            </Grid>
        </Box>
    );
}

function TrafficInfo() {
    const authenticated = useSelector(isAuthenticated);

    return authenticated? withDesktop(TrafficInfoContent)():withExplorer(TrafficInfoContent)();
}

export default TrafficInfo;